import 'rxjs/Rx';

import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { ApiService } from './api.service';

import {
  BehaviorSubject,
  throwError as observableThrowError,
  Observable,
  of as observableOf,
} from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IProfile } from '../interfaces/profile';
import { ICollaborators } from '../interfaces/collaborators';

@Injectable({
  providedIn: 'root',
})
export class OperadorService {
  private isOperadorLoggedIn: boolean;
  private isLoadingOperador: boolean;
  private myProfile: IProfile;

  private url_main_store = new BehaviorSubject<any>('');

  /**
   * Propriedade que será utilizada para filtro de data
   */
  url_estabelecimento = this.url_main_store.asObservable();

  constructor(private _apiService: ApiService) {
    this.isOperadorLoggedIn = false;
    this.isLoadingOperador = false;

    // se houver token armazenado verifica se é possivel se conectar
    var atoken = localStorage.getItem('sctoken');
    // console.log(atoken);
    if (atoken != null) {
      this._apiService.setAccessToken(atoken);
      this.isLoadingOperador = true;
    }
  }

  setUrlStore(url) {
    if (this.myProfile && this.myProfile.operador) {
      this.myProfile.operador.url_estabelecimento = url;
      this.url_main_store.next(url);
    }
  }

  profile(): Observable<boolean> {
    return this._apiService
      .doGET('operator')
      .pipe(
        map((data) => {
          const has = data['idoperador'] ? true : false;

          if (has) {
            this.authGuardOperadorIn({
              access_token: localStorage.getItem('sctoken'),
              operador: {
                idoperador: data['idoperador'],
                nome: data['nome'],
                sobrenome: data['sobrenome'],
                usuario: data['usuario'],
                foto: data['foto'],
                sc_tipo: data['sc_tipo'],
                url_estabelecimento: data['url_estabelecimento'],
                estabelecimento: data['estabelecimento'],
              },
            });
            this.setUrlStore(data['url_estabelecimento']);
          } else {
            this.authGuardOperadorOut();
          }

          return has;
        })
      )
      .pipe(
        catchError((err) => {
          this.authGuardOperadorOut();
          return observableThrowError(err.error_message);
        })
      );
  }

  login(usuario, senha): Observable<any> {
    return this._apiService
      .doPOST('operator/signin', { usuario, senha })
      .pipe(catchError((err) => observableThrowError(err.error_message)));
  }

  loginAdmin(id, token): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', `Bearer ${token}`);

    return this._apiService
      .doAPI('get', `operator/admin/signin?id=${id}`, null, null, headers)
      .pipe(catchError((err) => observableThrowError(err.error_message)));
  }

  authGuardOperadorIn(profile: IProfile) {
    this.isOperadorLoggedIn = true;
    this.isLoadingOperador = false;
    this.myProfile = profile;
  }

  authGuardOperadorOut() {
    this.isOperadorLoggedIn = false;
    this.isLoadingOperador = false;
    this.myProfile = null;

    this._apiService.removeAccessToken();
    localStorage.removeItem('sctoken');
  }

  setOperadorLoggedIn(profile: IProfile, mConectado: Boolean) {
    this.isOperadorLoggedIn = true;
    this.myProfile = profile;
    this._apiService.setAccessToken(profile.access_token);

    if (mConectado) {
      localStorage.setItem('sctoken', profile.access_token);
    }
  }

  isOperadorLoading() {
    return this.isLoadingOperador;
  }

  getOperadorLoggedIn() {
    return this.isOperadorLoggedIn;
  }

  getOperador() {
    if (this.myProfile) {
      return this.myProfile.operador;
    } else {
      return undefined;
    }
  }

  getAccess() {
    return this.myProfile.access_token;
  }

  getPermission(id: number, t: string) {
    if (this.myProfile.operador.sc_tipo == 'A') return true;

    for (let permisao of this.myProfile.operador.permissoes) {
      if (permisao.idpsmenu == id) {
        if (t == 'v') return true;
        if (t == 'i' && permisao.insert == 'S') return true;
        if (t == 'u' && permisao.update == 'S') return true;
        if (t == 'd' && permisao.delete == 'S') return true;
      }
    }
    return false;
  }

  /*
   *
   */
  find(): Observable<ICollaborators> {
    return this._apiService.doGET('collaborators').pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  store(data): Observable<any> {
    return this._apiService.doPOST('collaborators', data).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  patch(idoperador, data): Observable<any> {
    return this._apiService.doPATCH('collaborators/' + idoperador, data).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }
}
